const CLASS_NAME="math-option-with-fraction";
// Option lists are rendered by both shared engines and older task generators.
// Detect the mathematical A–F label rather than applying spacing to every formula.
export function normalizeMathOptionSpacing(katexNode){
 if(!(katexNode instanceof Element))return;
 const row=katexNode.closest("p,li,div");
 if(!row)return;
 const annotations=[...row.querySelectorAll('annotation[encoding="application/x-tex"]')];
 const startsWithOption=/^\s*(?:\\(?:displaystyle|textstyle)\s*)?[A-F]\s*[.)]/;
 const first=annotations[0]?.textContent || "";
 const isOption=startsWithOption.test(first)&&/^\s*[A-F]\s*[.)]/.test(row.textContent || "");
 const hasFraction=Boolean(row.querySelector(".mfrac"));
 row.classList.toggle(CLASS_NAME,isOption&&hasFraction);
}
